<div class="truncate">{{ value }}&nbsp;</div>
